var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.segments),function(segment,i){return [(segment.href)?_c('a',{key:i,attrs:{"href":segment.href,"target":segment.target,"rel":segment.rel}},[_vm._v(_vm._s(segment.text))]):_c('span',{key:i},[_vm._v(_vm._s(segment.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }